import { Container, ResourceIndicator } from '@bit/ui-common.ui-components/ss-components';
import { commonData, HelpLayout } from '@bit/ui-common.ui-components/ss-common-data';
import { ssFormServices, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { AfspLayout } from '@bit/ui-common.ui-components/afsp';
import { Select } from 'antd';

const 
{ Option } = Select,
{ setEnvPrefix } = ssCommonUtils,
imagesPath = '/home/images',
layout = {
    bgc: '#e6e6e6',
    controlType: 'login-analyst',
    size: { header: 'sm', footer: 'xs' },
    images: { 
        usePathname: false,
        logo: setEnvPrefix(`${imagesPath}/dhs-logo-01.png`),
        user: setEnvPrefix(`${imagesPath}/user-icon-01.png`),
        backgroundImage: setEnvPrefix(`${imagesPath}/home-image-full.jpg`)
    }
};

export default Container({
    state: ({ commonData }) => ({ commonData }),
    services: [ 
        ssFormServices,
        commonData.commonDataServices 
    ]
}, 
class extends React.Component {
    state = { portalContent: 'c' }
    constructor(props) { 
        super(props);
        const { services } = props;
        services.fetchTextData();
        services.fetchGeoData();
        services.fetchLookupData();
    }

    changePortalContent = v => this.setState({...this.state, portalContent: v });

    render() {
        const 
        { portalContent } = this.state,
        { commonData: { textData, geoData, lookupData }} = this.props;
        return (
            <div>
                <ResourceIndicator resources={{ textData, geoData, lookupData }} />
                <AfspLayout {...layout}>
                    <div className='home-analyst-portals-select'>
                        <span className='home-analyst-portals-select-title'>
                            {'Portal Content:'}
                        </span>
                        <Select
                            size='small'
                            placeholder={<i>{'Select a content type'}</i>}
                            style={{ width: '135px' }}
                            value={portalContent}
                            onSelect={this.changePortalContent}
                        >
                            <Option value='c'>{'Candidate'}</Option>
                            <Option value='p'>{'Provider'}</Option>
                            <Option value='f'>{'FSDO'}</Option>
                            <Option value='d'>{'DoD'}</Option>
                        </Select>
                    </div>
                    <HelpLayout
                        menuFull
                        format='home-page'
                        space='home-page'
                        theme='dark'
                        tab='c'
                        portal={portalContent}
                    />
                </AfspLayout>
            </div>
        )
    }
});